import { useState, useEffect } from 'react';
import api from '../services/api';
import { useI18n } from '../i18n';
import { formatDate } from '../i18n/utils';

// Gleitzeitkonto des eigenen Kontos (ohne userId) oder eines Benutzers (Admin-Detailseite).
export default function FlextimeCard({ userId }) {
  const { t, lang } = useI18n();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setError(false);
    api.get(userId ? `/flextime/users/${userId}` : '/flextime/me')
      .then((r) => { if (active) setData(r.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [userId]);

  const fmt = (v) => `${v > 0 ? '+' : ''}${v.toFixed(2)} ${t('flextime.hoursUnit')}`;
  const showDate = (v) => (lang === 'de' ? v : formatDate(v, lang));

  return (
    <div className="card mb-4" data-testid="flextime-card">
      <div className="card-header d-flex justify-content-between flex-wrap">
        <strong><i className="bi bi-hourglass-split me-2" />{t('flextime.title')}</strong>
        {data && <span className="text-muted small">{t('flextime.period', { from: showDate(data.start), to: showDate(data.end) })}</span>}
      </div>
      <div className="card-body">
        {error && <div className="text-danger">{t('flextime.error')}</div>}
        {!error && !data && <div className="spinner-border spinner-border-sm" />}
        {data && (
          <>
            <div className="row text-center g-2 mb-2">
              <div className="col">
                <div className="text-muted small">{t('flextime.balance')}</div>
                <div className={`fs-4 fw-bold ${data.balance_hours < 0 ? 'text-danger' : 'text-success'}`}>{fmt(data.balance_hours)}</div>
              </div>
              <div className="col">
                <div className="text-muted small">{t('flextime.worked')}</div>
                <div className="fs-5">{data.worked_hours.toFixed(2)} {t('flextime.hoursUnit')}</div>
              </div>
              <div className="col">
                <div className="text-muted small">{t('flextime.target')}</div>
                <div className="fs-5">{data.target_hours.toFixed(2)} {t('flextime.hoursUnit')}</div>
                <div className="text-muted small">{t('flextime.targetDetail', { days: data.target_days, hours: data.daily_target_hours })}</div>
              </div>
              <div className="col">
                <div className="text-muted small">{t('flextime.fzt')}</div>
                <div className="fs-5">{data.fzt_hours.toFixed(2)} {t('flextime.hoursUnit')}</div>
                <div className="text-muted small">{t('flextime.fztDetail', { days: data.fzt_days })}</div>
              </div>
            </div>
            <div className="text-muted small">{t('flextime.excluded', { days: data.excluded_days })}</div>
            <div className="text-muted small">{t('flextime.hint')}</div>
          </>
        )}
      </div>
    </div>
  );
}
